module.exports = __webpack_public_path__ + "static/media/datapoints.bdee8185.svg";